export enum AiAgentStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}

export type AiAgentTaskContext = 'ALERT' | 'CASE' | 'FILING';

export interface AIAgentDetailsParams {
  agent_id: string;
}
